var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurkmenistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C18.5067 0 17.0521 0.165078 15.6522 0.475391L14.7827 19.9999L15.6522 39.5245C17.0522 39.8348 18.5068 40 20 40C31.0457 40 40 31.0456 40 19.9999C39.9999 8.9543 31.0457 0 20 0V0Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21737 6.52893C1.97644 10.0833 3.05176e-05 14.8106 3.05176e-05 19.9999C3.05176e-05 25.1891 1.97651 29.9164 5.21745 33.471L6.08698 19.9999L5.21737 6.52893Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2516 15.0857C30.2356 12.343 29.1301 9.36014 26.7577 7.87451C27.1844 7.93006 27.6116 8.03053 28.0332 8.1817C31.1975 9.31701 32.8423 12.8023 31.707 15.9665C30.5717 19.131 27.0864 20.7757 23.9221 19.6404C23.5005 19.4891 23.1068 19.295 22.7422 19.0666C25.518 19.4281 28.2676 17.8283 29.2516 15.0857V15.0857Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.794 7.1228L22.9389 8.22765L21.6242 7.75585L22.4106 8.91038L21.5556 10.0151L22.8967 9.62397L23.6832 10.7783L23.7254 9.3821L25.0665 8.99093L23.7517 8.51929L23.794 7.1228Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1028 10.7227L25.2477 11.8274L23.9329 11.3556L24.7193 12.5102L23.8643 13.6148L25.2053 13.2236L25.9919 14.3782L26.0343 12.9819L27.3753 12.5906L26.0604 12.1189L26.1028 10.7227Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7234 8.43396L18.8684 9.53865L17.5536 9.06701L18.3401 10.2215L17.4851 11.3262L18.826 10.9351L19.6126 12.0895L19.6549 10.6933L20.9959 10.3021L19.6812 9.83029L19.7234 8.43396Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6297 12.5575L18.7747 13.6623L17.4599 13.1905L18.2464 14.3451L17.3913 15.4498L18.7324 15.0587L19.5189 16.213L19.5612 14.8168L20.9023 14.4256L19.5874 13.9538L19.6297 12.5575Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5536 13.9653L22.6985 15.07L21.3837 14.5983L22.1703 15.7528L21.3151 16.8574L22.6563 16.4663L23.4428 17.6209L23.4851 16.2245L24.8261 15.8334L23.5112 15.3617L23.5536 13.9653Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21747 6.52893V33.4709C7.94247 36.4595 11.562 38.6177 15.6522 39.5244V0.475342C11.5619 1.38206 7.94255 3.54026 5.21747 6.52893V6.52893Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19944 10.53L7.45248 9.22863V7.38824L9.19944 6.08691H11.6701L13.4171 7.38824V9.22863L11.6701 10.53H9.19944Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 6.08704H9.19941L7.45245 7.38836V8.28813H10.4348V6.08704Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 10.5302H11.6701L13.417 9.22874V8.28992H10.4348V10.5302Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19944 33.913L7.45248 32.6116V30.7713L9.19944 29.4698H11.6701L13.4171 30.7713V32.6116L11.6701 33.913H9.19944Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 29.4698H9.19941L7.45245 30.7713V31.671H10.4348V29.4698Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 33.913H11.6701L13.417 32.6116V31.6729H10.4348V33.913Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19964 22.2216L7.45268 20.9202V19.0798L9.19964 17.7784H11.6703L13.4173 19.0798V20.9202L11.6703 22.2216H9.19964Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4784 25.0847H12.7175V24.3239H11.3804L10.4349 23.3784L9.48954 24.3239H8.15243V25.0847H7.39157V26.6065H8.15243V27.3673H9.48946L10.435 28.3129L11.3804 27.3673H12.7175V26.6065H13.4784V25.0847Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4784 13.3933H12.7175V12.6324H11.3804L10.4349 11.6869L9.48954 12.6324H8.15243V13.3933H7.39157V14.915H8.15243V15.6759H9.48946L10.435 16.6215L11.3804 15.6759H12.7175V14.915H13.4784V13.3933Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56508 19.1305H11.3042V20.8696H9.56508V19.1305Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4346 15.0235C10.9148 15.0235 11.3041 14.6342 11.3041 14.154C11.3041 13.6737 10.9148 13.2844 10.4346 13.2844C9.95438 13.2844 9.56508 13.6737 9.56508 14.154C9.56508 14.6342 9.95438 15.0235 10.4346 15.0235Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4346 26.7156C10.9148 26.7156 11.3041 26.3263 11.3041 25.8461C11.3041 25.3659 10.9148 24.9766 10.4346 24.9766C9.95438 24.9766 9.56508 25.3659 9.56508 25.8461C9.56508 26.3263 9.95438 26.7156 10.4346 26.7156Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkmenistan);
export default __webpack_public_path__ + "static/media/turkmenistan.6085b3022d240d86192760857ce99814.svg";
export { ForwardRef as ReactComponent };